export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/logo-dhl.3ba2da6f.svg","height":40,"width":100,"blurWidth":0,"blurHeight":0};